import { Box, Typography, Select, MenuItem, Stack, SelectChangeEvent } from "@mui/material";
import { useCallback, useMemo } from "react";
import { langList } from "~/shared/utils/googleConst";
import { DeleteIcon } from "~/shared/icons/DeleteIcon";
import { ILanguageSelector2Props } from "~/shared/types/types";

export const LanguageSelector2 = ({ setLang, lang, }: ILanguageSelector2Props) => {

  const formatLangShort = (name: string) => {
    const match = name.match(/^(\w+)\s*\(([^)]+)\)$/);
    if (match) {
      const [_, lang, region] = match;
      return `${lang.slice(0, 2).toUpperCase()} ${region.slice(0, 2).toUpperCase()}`;
    }
    return name.slice(0, 2).toUpperCase();
  };


  // Обработчик языка
  const handleLang = useCallback(
    (e: any) => {
      if (lang.includes(e.target.value)) {
        const langArr = lang.filter(item => item !== e.target.value);
        setLang(langArr);
      } else {
        const langArr = [...lang, e.target.value as string];
        setLang(langArr);
      }
    },
    [lang, setLang],
  );

  const removeLang = useCallback(
    (item: any) => {
      setLang(lang.filter(l => l !== item));
    },
    [lang, setLang],
  );

  const labelLang = useMemo(() => {
    return langList.filter((item: any) => lang.includes(item.id));
  }, [lang]);

  return (
    <Box
      display="flex" flexDirection="column" gap={0.5}
    >
      <Typography fontWeight={600} variant="subtitle2" sx={{ fontSize: '14px' }}>
        Языки:
      </Typography>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={typeof lang === 'number' ? lang : ''}
        label="Language"
        onChange={handleLang as any}>
        {langList.map((language: any) => {
          return (
            <MenuItem key={language.id} value={language.id}>
              {language.name}
            </MenuItem>
          );
        })}
      </Select>
      <Stack display="flex" flexDirection="row" pt={2} gap={1}>
        {labelLang.map((item: any, index: number) => {
          return (
            <Box
              key={index}
              sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: '6px',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                padding: '6px 9px',
                backgroundColor: 'hsl(210, 98.4%, 47.8%)',
                border: '1px solid hsl(210, 100%, 92%)',
                borderRadius: '4px',
                whiteSpace: 'nowrap',
                maxWidth: '100px',
                color: '#fff',
              }}>
              {formatLangShort(item.name)}
              <Box sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                <DeleteIcon size={22} handleClick={() => removeLang(item.id)} />
              </Box>
            </Box>
          );
        })}
      </Stack>
    </Box>
  );
}
